module.exports = __webpack_public_path__ + "static/media/icons8-slack-new.300b2126.svg";